import { isDetailsPage } from '@features/filter/static/filterUtil';

import { Types } from '@store/types';

const storeItemInGlobalFIlter = (selectedField, action, cloneState, state) => {
	let tmpState = JSON.parse(JSON.stringify(cloneState));
	if (!([action.payload.name] in state)) {
		tmpState[action.payload.name] = [
			{
				...action.payload
			}
		];
		return { ...tmpState };
	} else {
		if (action.payload.checked === true) {
			selectedField = [...selectedField, action.payload];
			selectedField = [...new Map(selectedField.map((item) => [item.key, item])).values()];
		} else if (action.payload.type === 'SELECT') {
			selectedField = [];
			selectedField.push(action.payload);
		} else if (action.payload.type === 'INPUT_VALUE') {
			tmpState[action.payload.name] = [
				{
					...action.payload
				}
			];
			return { ...tmpState };
		} else if (action.payload.type === 'COMPOSITION') {
			tmpState[action.payload.name] = [
				...state.fabricCompositionPartSearchDtoList,
				{
					...action.payload
				}
			];
			return { ...tmpState };
		} else if (action.payload.type === 'OFFER_PRICE') {
			const updatedOfferPriceList = state.offerPriceList?.some(
				(item) => item.brandId === action.payload.brandId
			)
				? state.offerPriceList?.map((item) =>
						item.brandId === action.payload.brandId ? { ...item, ...action.payload } : item
					)
				: [...state.offerPriceList, { ...action.payload }];

			tmpState[action.payload.name] = updatedOfferPriceList;
			return { ...tmpState };
		} else {
			selectedField = selectedField.filter((item) => item.identifier !== action.payload.identifier);
			if (action.payload.type === 'dateRange') {
				selectedField.push(action.payload);
			}
		}

		tmpState[action.payload.name] = selectedField;
		if (tmpState[action.payload.name].length === 0) {
			delete tmpState[action.payload.name];
		}
		return tmpState;
	}
};

const upDAteTextItemInGlobalFilter = (selectedField, action, tmpState) => {
	if (selectedField !== undefined) {
		let selectedIndex = selectedField.findIndex((item) => item.identifier === action.payload.identifier);
		selectedField[selectedIndex].isClearable = action.payload.isClearable || true;
		selectedField[selectedIndex].key = action.payload.key;
		selectedField[selectedIndex].value = action.payload.value;
		selectedField[selectedIndex].label = action.payload?.label || '';
		selectedField[selectedIndex].additionalData = action.payload?.additionalData || null;
		tmpState[action.payload.name] = selectedField;
		if (action.payload.key === '') {
			delete tmpState[action.payload.name];
		}
	} else {
		tmpState[action.payload.name] = [
			{
				...action.payload
			}
		];
	}

	return tmpState;
};
const updateTextItemMultipleInGlobalFilter = (selectedField, action, tmpState) => {
	if (selectedField !== undefined) {
		//let selectedIndex = selectedField.findIndex((item) => item.identifier === action.payload.name);
		selectedField = [];
		action.payload.list.forEach((item) => {
			selectedField.push({
				identifier: action.payload.name,
				isClearable: item.isClearable || true,
				key: item.key,
				value: item.value,
				label: item.label || '',
				additionalData: item.additionalData || null
			});
		});

		tmpState[action.payload.name] = selectedField;
		// if (action.payload.key === '') {
		// 	delete tmpState[action.payload.name];
		// }
	} else {
		tmpState[action.payload.name] = [...action.payload.list];
	}

	return tmpState;
};

const initialState = { DETAILS_PAGE_FILTERS: {}, clearAll: false, clearOne: false };

export const FilterFieldReducer = (state = initialState, action) => {
	let tmpState = { ...state };
	let selectedField;

	if (action?.payload?.name) {
		if (isDetailsPage()) {
			if (state['stages'] || state['statusList'] || state['tags']) {
				selectedField = state[action.payload.name];
			} else {
				selectedField = state['DETAILS_PAGE_FILTERS']?.[action.payload.name];
			}
		} else {
			selectedField = state[action.payload.name];
		}
	}

	switch (action.type) {
		case Types.STORE_INITIAL_ITEM_IN_GLOBAL_FILTER:
			return { ...tmpState, ...action.payload };
		case Types.STORE_ITEM_IN_GLOBAL_FILTER: {
			let emptyObj = { ...state };
			if (!isDetailsPage()) {
				emptyObj = storeItemInGlobalFIlter(
					selectedField,
					action,
					{ ...tmpState, DETAILS_PAGE_FILTERS: {} },
					{ ...state, DETAILS_PAGE_FILTERS: {} }
				);
			}
			if (isDetailsPage()) {
				emptyObj['DETAILS_PAGE_FILTERS'] = storeItemInGlobalFIlter(
					selectedField,
					action,
					tmpState.DETAILS_PAGE_FILTERS,
					state.DETAILS_PAGE_FILTERS
				);
			}
			return emptyObj;
		}
		case Types.UPDATE_TEXT_ITEM_IN_GLOBAL_FILTER: {
			let emptyObj = { ...state };

			if (!isDetailsPage()) {
				emptyObj = upDAteTextItemInGlobalFilter(selectedField, action, {
					...tmpState,
					DETAILS_PAGE_FILTERS: {}
				});
			}
			if (isDetailsPage()) {
				emptyObj['DETAILS_PAGE_FILTERS'] = upDAteTextItemInGlobalFilter(
					selectedField,
					action,
					tmpState.DETAILS_PAGE_FILTERS || {}
				);
			}
			return emptyObj;
		}
		case Types.UPDATE_TEXT_ITEM_MULTIPLE_IN_GLOBAL_FILTER: {
			let emptyObj = { ...state };
			if (!isDetailsPage()) {
				emptyObj = updateTextItemMultipleInGlobalFilter(selectedField, action, {
					...tmpState,
					DETAILS_PAGE_FILTERS: {}
				});
			}
			if (isDetailsPage()) {
				emptyObj['DETAILS_PAGE_FILTERS'] = updateTextItemMultipleInGlobalFilter(
					selectedField,
					action,
					tmpState.DETAILS_PAGE_FILTERS
				);
			}
			return { ...emptyObj, clearAll: false };
		}

		case Types.CLEAR_GLOBAL_FILTER: {
			let emptyObj = {};
			let detailsEmptyObj = {};
			const clearFields = (item, objectFields) => {
				if (state[item] !== undefined && typeof state?.[item] === 'object') {
					if (Array.isArray(state[item])) {
						for (let obj of state[item]) {
							if ('isClearable' in obj && obj.isClearable === false) {
								objectFields[item] = state[item];
								break;
							}
						}
					}
				}
			};
			for (let item in state) {
				if (state?.[item] && Object.entries(state?.[item]).length === 0) {
					if (isDetailsPage()) {
						for (let itemField in state['DETAILS_PAGE_FILTERS']) {
							clearFields(itemField, detailsEmptyObj);
						}
					} else {
						if (item !== 'DETAILS_PAGE_FILTERS' || item !== 'clearAll')
							clearFields(item, emptyObj);
					}
				}
			}
			return (state = { ...emptyObj, DETAILS_PAGE_FILTERS: { ...detailsEmptyObj } });
		}
		case Types.REMOVE_ITEM_FROM_GLOBAL_FILTER:
			//selectedField = selectedField?.filter((item) => item.identifier !== action.payload.identifier);
			// if (isDetailsPage()) {
			// 	console.log('isDetailsPage', isDetailsPage);
			// 	if (state['stages'] || state['statusList'] || state['tags']) {
			// 		tmpState[action.payload.name] = selectedField;
			// 		if (tmpState[action.payload.name]?.length === 0) {
			// 			delete tmpState[action.payload.name];
			// 		}
			// 	} else {
			// 		tmpState['DETAILS_PAGE_FILTERS'][action.payload.name] = selectedField;
			// 		if (tmpState['DETAILS_PAGE_FILTERS'][action.payload.name]?.length === 0) {
			// 			delete tmpState['DETAILS_PAGE_FILTERS'][action.payload.name];
			// 		}
			// 	}
			// } else {
			// 	const updatedField = (tmpState[action.payload.identifier] || []).filter(
			// 		(item) => item.value !== action.payload.value
			// 	);

			// 	// Update the state with the filtered array
			// 	tmpState[action.payload.identifier] = updatedField;

			// 	// If the updated array is empty, delete the property from the state
			// 	if (updatedField.length === 0) {
			// 		delete tmpState[action.payload.identifier];
			// 	}
			// }
			// return tmpState;
			selectedField = selectedField?.filter((item) => item.identifier !== action.payload.identifier);
			if (isDetailsPage()) {
				if (state['stages'] || state['statusList'] || state['tags']) {
					tmpState[action.payload.name] = selectedField;
					if (tmpState[action.payload.name]?.length === 0) {
						delete tmpState[action.payload.name];
					}
				} else {
					tmpState['DETAILS_PAGE_FILTERS'][action.payload.name] = selectedField;
					if (tmpState['DETAILS_PAGE_FILTERS'][action.payload.name]?.length === 0) {
						delete tmpState['DETAILS_PAGE_FILTERS'][action.payload.name];
					}
				}
			} else {
				tmpState[action.payload.name] = selectedField;
				if (tmpState[action.payload.name]?.length === 0) {
					delete tmpState[action.payload.name];
				}
				if (!action.payload.name && tmpState[action.payload.identifier]?.length > 0) {
					const targetArray = tmpState[action.payload.identifier];
					tmpState[action.payload.identifier] = targetArray.filter(
						(chip) => chip.key !== action.payload.key
					);
				}
			}
			return { ...tmpState, clearOne: true };
		case Types.CLEAR_GLOBAL_FILTER_WITH_EXCLUDE: {
			let emptyObj = {};
			let cloneState;
			if (isDetailsPage() && !(state['stages'] || state['statusList'] || state['tags'])) {
				cloneState = state['DETAILS_PAGE_FILTERS'];
			} else {
				cloneState = state;
			}

			let updatedObj = { ...state };

			for (let item of action.payload) {
				if (item in cloneState) {
					emptyObj[item] = cloneState[item];
				}
			}
			if (!isDetailsPage()) {
				updatedObj = {
					...emptyObj,
					DETAILS_PAGE_FILTERS: {},
					clearAll: true,
					clearOne: false
					//dateRange: state.dateRange
				};
			}
			if (isDetailsPage() && !(state['stages'] || state['statusList'] || state['tags'])) {
				updatedObj = {
					[action.payload]: state[action.payload],
					...cloneState,
					DETAILS_PAGE_FILTERS: { ...emptyObj },
					clearAll: true,
					clearOne: false
				};
			}
			if (isDetailsPage() && (state['stages'] || state['statusList'] || state['tags'])) {
				updatedObj = {
					...emptyObj,
					DETAILS_PAGE_FILTERS: {},
					clearAll: true,
					clearOne: false
				};
			}

			return updatedObj;
		}
		case Types.CLEAR_GLOBAL_FILTER_WITH_DATE: {
			let updatedObj = { ...state };
			const { ...restData } = state;
			updatedObj = {
				...restData,
				dateRange: undefined
			};
			return updatedObj;
		}

		case Types.REPLACE_DETAILS_PAGE_FILTER_FIELDS: {
			return { ...state, ...action.payload };
		}

		case Types.CLEAR_GLOBAL_FILTER_SELECTED_FIELDS: {
			let remainingObjs = isDetailsPage() ? state['DETAILS_PAGE_FILTERS'] : { ...tmpState };
			for (let item of action.payload) {
				if (item in remainingObjs) {
					delete remainingObjs[item];
				}
			}
			return remainingObjs;
		}
		case Types.CLEAR_DETAILS_PAGE_GLOBAL_FILTER:
			return { ...state, DETAILS_PAGE_FILTERS: {} };
		default:
			return state;
	}
};

const responseState = {};

const filterResponseDataArray = (state) => (Array.isArray(state?.data) ? state.data : []);

export const FilterResponseReducer = (state = responseState, action) => {
	let data;
	switch (action.type) {
		case Types.FETCH_GLOBAL_FILTER_DATA: {
			let payloadData = Array.isArray(action?.payload?.data) ? action?.payload?.data : [];
			data =
				state?.data !== undefined && action?.payload?.merge && Array.isArray(state?.data)
					? [...state.data, ...payloadData]
					: [...payloadData];
			return { ...action?.payload, data: data };
		}
		case Types.REMOVE_ITEM_FROM_FILTER_RESPONSE:
			data = [...filterResponseDataArray(state)];
			data = data?.filter((item) => item?.id !== action?.payload);
			return { ...state, data: data, totalElements: state.totalElements - 1 };

		case Types.ADD_ITEM_IN_GLOBAL_FILTER_DATA: {
			data = [action?.payload, ...filterResponseDataArray(state)];
			return { ...state, data: data, totalElements: state?.totalElements + 1 };
		}
		case Types.UPDATE_GLOBAL_FILTER_DATA: {
			data = [...filterResponseDataArray(state)];
			let selectedDataIndex = data?.findIndex((item) => item?.id === action?.payload?.id);
			if (selectedDataIndex !== -1) {
				data[selectedDataIndex] = action?.payload;
			}
			return { ...state, data: data };
		}
		case Types.UPDATE_DESIGN_INFO_SUCCESS: {
			data = [...filterResponseDataArray(state)];
			let selectedData = data?.find((item) => item?.id === action?.payload?.id);
			selectedData.fabricName = action?.payload?.fabricDetails;
			return { ...state, data: data };
		}
		case Types.SET_PINNED_COLLECTION: {
			data = [...filterResponseDataArray(state)];
			let pinnedData = data?.find((item) => item?.id === action?.payload);
			pinnedData.isPinned = true;
			data = data?.filter((item) => item?.id !== action?.payload);
			data?.unshift?.(pinnedData);
			return { ...state, data: data };
		}
		case Types.SET_UNPINNED_COLLECTION: {
			data = [...filterResponseDataArray(state)];
			data?.map((item) => {
				if (item?.id === action?.payload) {
					item.isPinned = false;
				}
			});
			return { ...state, data: data };
		}
		case Types.SET_HAS_MENTIONED_ID: {
			data = [...filterResponseDataArray(state)];
			data?.map((item) => {
				if (item?.id === action?.payload) {
					item.hasUnseenMention = true;
				}
			});
			return { ...state, data: data };
		}
		case Types.CLEAR_GLOBAL_FILTER_RESPONSE:
			return (state = {});
		default:
			return state;
	}
};

export const SlectedCheckBoxFieldReducer = (state = { selectedCheckboxField: null }, action) => {
	switch (action.type) {
		case Types.STORE_SELECTED_FILTER_CHECK_BOX_TYPE:
			return { selectedCheckboxField: action?.payload };
		case Types.CLEAR_SELECTED_FILTER_NAME:
			return { selectedCheckboxField: null };
		default:
			return state;
	}
};

export const MultiLevelFilterReducer = (state = { multiLevelFilters: [] }, action) => {
	switch (action.type) {
		case Types.STORE_IN_MULTI_LEVEL_FILTER: {
			const newData = action?.payload || { filterLevel: 1 };
			let updatedFilters = [...state.multiLevelFilters];
			updatedFilters = updatedFilters.filter(
				(data) =>
					data?.filterLevel !== newData?.filterLevel && data?.filterLevel <= newData?.filterLevel
			);

			updatedFilters.push(newData);

			const allSelectedFilterLevel = updatedFilters?.map((item) => item?.filterLevel);
			const currentSelectedFilterLevel = Math.max(...allSelectedFilterLevel);

			return {
				...state,
				multiLevelFilters: updatedFilters,
				currentSelectedFilterLevel
			};
		}

		case Types.UPDATE_IN_MULTI_LEVEL_FILTER: {
			let updatedFilters = [...state.multiLevelFilters];
			updatedFilters = updatedFilters.filter((data) => data?.filterLevel <= action?.payload);
			const allSelectedFilterLevel = updatedFilters?.map((item) => item?.filterLevel);
			const currentSelectedFilterLevel = Math.max(...allSelectedFilterLevel);

			return {
				...state,
				multiLevelFilters: updatedFilters,
				currentSelectedFilterLevel
			};
		}
		default:
			return state;
	}
};

export const DependentFilterListReducer = (
	state = { dependentFilterList: null, filterListPage: null },
	action
) => {
	switch (action.type) {
		case Types.STORE_DEPENDENT_FILTER_LIST:
			return {
				dependentFilterList: action?.payload?.responseData,
				filterListPage: action?.payload?.filterListPage
			};
		default:
			return state;
	}
};

export const ToggleBlockSuggestionFilterReducer = (
	state = { isShowBlockSuggestionFilter: false },
	action
) => {
	switch (action.type) {
		case Types.TOGGLE_BLOCK_SUGGESTIONS_FILTER:
			return {
				isShowBlockSuggestionFilter: action?.payload
			};
		default:
			return state;
	}
};
